import React, { useState, useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SolutionsSection from './components/SolutionsSection';
import WhyChooseSection from './components/WhyChooseSection';
import RecognitionSection from './components/RecognitionSection';
import CtaBanner from './components/CtaBanner';
import Footer from './components/Footer';
import ContactPage from './components/ContactPage';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Initialize Lenis smooth scroll for Webflow-like physics
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.8,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, [currentPage]);

  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      {currentPage === 'home' ? (
        <>
          <HeroSection onNavigate={handleNavigate} />
          <AboutSection />
          <SolutionsSection />
          <WhyChooseSection />
          <RecognitionSection />
          <CtaBanner onNavigate={handleNavigate} />
          <Footer onNavigate={handleNavigate} />
        </>
      ) : (
        <ContactPage onNavigate={handleNavigate} />
      )}
    </div>
  );
}

export default App;
